module.exports = __webpack_public_path__ + "img/air-max-270-react-mens-shoe.80933a46.png";